import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

type UpdateSwiftlaneResidentRequest = {
  buildingId: number
  userEmail: string
  userGroupIds: string[]
  expirationDate?: number
}

const updateSwiftlaneResident = async (data: UpdateSwiftlaneResidentRequest) => {
  const response = await authAPI.put(`/building/${data.buildingId}/swiftlane/resident`, {
    expirationDate: data.expirationDate,
    userEmail: data.userEmail,
    userGroupIds: data.userGroupIds,
  })
  return response.data
}

export const useUpdateSwiftlaneResident = () =>
  useMutation({
    mutationFn: updateSwiftlaneResident,
  })
